// src/router/sessions.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const sessionsBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Usuário ativos',
        to: 'Sessions'
    }
]

export default [
    {
        path: '/usuarios-ativos',
        name: 'Sessions',
        component: () => import('@/views/Sessions/SessionListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Usuário ativos',
            breadcrumb: sessionsBreadCrumb
        },
    }
];
